import React from 'react'

/**
 * Catches render-time exceptions so an unexpected error shows a friendly screen
 * instead of a blank page. Wraps the routed app.
 */
export default class ErrorBoundary extends React.Component {
  constructor (props) {
    super(props)
    this.state = { hasError: false }
  }

  static getDerivedStateFromError () {
    return { hasError: true }
  }

  componentDidCatch (error, info) {
    console.error('UI error boundary caught:', error, info)
  }

  handleReload = () => {
    window.location.reload()
  }

  render () {
    if (this.state.hasError) {
      return (
        <div className='min-h-[70vh] flex items-center justify-center px-5 text-center'>
          <div>
            <div className='text-5xl mb-4'>⚠️</div>
            <h1 className='text-xl font-bold text-gray-900 mb-2'>Something went wrong</h1>
            <p className='text-gray-500 mb-6'>Please try reloading the page.</p>
            <button
              type='button'
              onClick={this.handleReload}
              className='bg-[#065f2a] text-white font-semibold px-6 py-3 rounded-xl'
            >
              Reload
            </button>
          </div>
        </div>
      )
    }
    return this.props.children
  }
}
